import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';

export const ForgotPassword = () => {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#06120B' }}>
      <Card className="w-full max-w-md" data-testid="forgot-password-card">
        <CardHeader>
          <CardTitle className="text-xl">Reset Password</CardTitle>
          <CardDescription>Enter your email to receive a reset link</CardDescription>
        </CardHeader>
        <CardContent>
          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="forgot-error">{error}</div>
              )}
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@company.com" data-testid="forgot-email" />
              </div>
              <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700" disabled={loading} data-testid="forgot-submit">
                {loading ? 'Sending...' : <><Mail className="w-4 h-4 mr-2" /> Send Reset Link</>}
              </Button>
              <div className="text-center text-sm text-gray-500">
                <Link to="/auth/login" className="inline-flex items-center gap-1 text-emerald-600 hover:underline">
                  <ArrowLeft className="w-3.5 h-3.5" /> Back to login
                </Link>
              </div>
            </form>
          ) : (
            <div className="space-y-4" data-testid="forgot-success">
              <div className="flex flex-col items-center text-center py-4">
                <CheckCircle className="w-12 h-12 text-emerald-500 mb-3" />
                <p className="text-sm text-gray-700 font-medium mb-1">Check your email</p>
                <p className="text-sm text-gray-500">
                  If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
                </p>
              </div>
              <div className="text-center text-sm text-gray-500">
                <Link to="/auth/login" className="inline-flex items-center gap-1 text-emerald-600 hover:underline">
                  <ArrowLeft className="w-3.5 h-3.5" /> Back to login
                </Link>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
